import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';

import { ImproveWritingIcon } from '../../../../icons/prompt/improveWriting';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export const improveWritingADFFullDocument: EditorPluginAIConfigItem = {
	key: CONFIG_ITEM_KEYS.IMPROVE_WRITING,
	title: aiConfigItemMessages.improveWritingTitle,
	description: aiConfigItemMessages.improveWritingDescription,
	icon: () => <ImproveWritingIcon />,
	intentSchemaId: 'improve_quality_full_document_intent_schema.json',
	adfPrompt: true,
	actions: {
		empty: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
		selection: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
	canToggleDiffPreview: true,
};

export const improveWritingADFFullDocumentWithOptions: EditorPluginAIConfigItemWithOptions = {
	config: improveWritingADFFullDocument,
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: false } },
};
